import { render, staticRenderFns } from "./DictTypeList.vue?vue&type=template&id=1f186d33"
import script from "./DictTypeList.vue?vue&type=script&lang=js"
export * from "./DictTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f186d33')) {
      api.createRecord('1f186d33', component.options)
    } else {
      api.reload('1f186d33', component.options)
    }
    module.hot.accept("./DictTypeList.vue?vue&type=template&id=1f186d33", function () {
      api.rerender('1f186d33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/sys/dict/DictTypeList.vue"
export default component.exports